import { TuitionFeeCollection } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    collections: [],
    collection: {},
    customQuery: {},
    totalItems: 0,
    pageText: '',
    itemsPerPage: 10
  },
  actions: {
    async fetchCollections({ commit }, params) {
      let countParams = { ...params, _limit: null, _start: null }
      const [totalItems, collections] = await Promise.all([
        TuitionFeeCollection.count(countParams),
        TuitionFeeCollection.fetch(params)
      ])
      commit('changeState', { collections, totalItems })
      return collections
    },
    async fetchCollection({ commit }, payload) {
      let collection = await TuitionFeeCollection.fetchOne(payload)
      commit('changeState', { collection })
      return collection
    },
    async creatCollection({ dispatch }, payload) {
      await TuitionFeeCollection.create(payload)
      dispatch('getCollectionByPagination', {})
    },
    async updateCollection({ state, commit }, payload) {
      await TuitionFeeCollection.update(payload.id, payload.data)
      let collections = state.collections.map(item =>
        item.id === payload.id
          ? { ...item, title: payload.data.title && payload.data.title, rank: payload.data.rank && payload.data.rank }
          : item
      )
      commit('changeState', { collections: collections })
    },
    async removeCollection({ state, commit }, payload) {
      await TuitionFeeCollection.remove(payload)
      let collections = state.collections.filter(item => item.id !== payload)
      commit('changeState', { collections: collections })
    },
    setPageText({ state, commit }, { page, itemsPerPage }) {
      const pageStart = (page - 1) * itemsPerPage + 1
      let pageStop = page * itemsPerPage
      pageStop = pageStop > state.totalItems || pageStop === -1 ? state.totalItems : pageStop
      let pageText = `${pageStart}-${pageStop} trên ${state.totalItems}`
      commit('changeState', { pageText })
    },
    async getCollectionByPagination({ state, dispatch }, { page, itemsPerPage }) {
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      let params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage
      }
      await dispatch('fetchCollections', params)
      await dispatch('setPageText', { page, itemsPerPage })
    }
  },
  mutations: {
    resetData(state) {
      state.collection = {}
      state.collections = []
    },
    setCustomQuery(state, payload) {
      state.customQuery = payload
    },
    setCollection(state, payload) {
      state.collections = payload
    }
  },
  getters: {
    collection: state => state.collection,
    collections: state => state.collections,
    totalItems: state => state.totalItems,
    pageText: state => state.pageText,
    customQuery: state => state.customQuery
  }
}
